// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default icon size */
.leading-icon .svg-icon {
  margin-inline-end: 0.5rem;
  vertical-align: top;
}
.leading-icon .svg-icon--100 {
  margin-inline-end: 0.25rem;
}

.trailing-icon .svg-icon {
  margin-inline-start: 0.5rem;
  vertical-align: top;
}
.trailing-icon .svg-icon--100 {
  margin-inline-start: 0.25rem;
}

.svg-icon {
  display: inline-block;
  height: 1.5rem;
  width: 1.5rem;
  vertical-align: middle;
  fill: currentColor;
  transition-property: transform, fill;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.4, 1);
}
@media (prefers-reduced-motion) {
  .svg-icon {
    transition-property: none;
  }
}

@keyframes icon-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.svg-icon--rotate {
  animation: icon-rotate 1.5s linear infinite;
}

.svg-icon--rotate-45 {
  transform: rotate(45deg);
}

.svg-icon--rotate-minus-45 {
  transform: rotate(-45deg);
}

.svg-icon--rotate-135 {
  transform: rotate(135deg);
}

.svg-icon--rotate-minus-135 {
  transform: rotate(-135deg);
}

.svg-icon--rotate-180 {
  transform: rotate(180deg);
}

.svg-icon--rotate-minus-180 {
  transform: rotate(-180deg);
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/svg-icon/dist/style.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,wDAAwD;AAC1D;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Default icon size */\n.leading-icon .svg-icon {\n  margin-inline-end: 0.5rem;\n  vertical-align: top;\n}\n.leading-icon .svg-icon--100 {\n  margin-inline-end: 0.25rem;\n}\n\n.trailing-icon .svg-icon {\n  margin-inline-start: 0.5rem;\n  vertical-align: top;\n}\n.trailing-icon .svg-icon--100 {\n  margin-inline-start: 0.25rem;\n}\n\n.svg-icon {\n  display: inline-block;\n  height: 1.5rem;\n  width: 1.5rem;\n  vertical-align: middle;\n  fill: currentColor;\n  transition-property: transform, fill;\n  transition-duration: 250ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.4, 1);\n}\n@media (prefers-reduced-motion) {\n  .svg-icon {\n    transition-property: none;\n  }\n}\n\n@keyframes icon-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n.svg-icon--rotate {\n  animation: icon-rotate 1.5s linear infinite;\n}\n\n.svg-icon--rotate-45 {\n  transform: rotate(45deg);\n}\n\n.svg-icon--rotate-minus-45 {\n  transform: rotate(-45deg);\n}\n\n.svg-icon--rotate-135 {\n  transform: rotate(135deg);\n}\n\n.svg-icon--rotate-minus-135 {\n  transform: rotate(-135deg);\n}\n\n.svg-icon--rotate-180 {\n  transform: rotate(180deg);\n}\n\n.svg-icon--rotate-minus-180 {\n  transform: rotate(-180deg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
